import { useState, useEffect, useRef, useCallback } from "react";
import { Trophy, RefreshCw, Pause, Play, HelpCircle } from "lucide-react";
import axios from "axios";

// ==================== EXPANDED TRIVIA QUESTION DATABASE (200+ QUESTIONS) ====================

// Main All Category - Hard questions from all categories (50 questions)
const MAIN_TRIVIA_QUESTIONS = [
  // World Capitals (15)
  { id: "cap1", question: "What is the capital of Mongolia?", answer: "ulaanbaatar", category: "Capitals", points: 20 },
  { id: "cap2", question: "What is the capital of Bhutan?", answer: "thimphu", category: "Capitals", points: 20 },
  { id: "cap3", question: "What is the capital of Madagascar?", answer: "antananarivo", category: "Capitals", points: 20 },
  { id: "cap4", question: "What is the capital of Myanmar?", answer: "naypyidaw", category: "Capitals", points: 20 },
  { id: "cap5", question: "What is the capital of Kazakhstan?", answer: "astana", category: "Capitals", points: 15 },
  { id: "cap6", question: "What is the capital of Slovenia?", answer: "ljubljana", category: "Capitals", points: 20 },
  { id: "cap7", question: "What is the capital of Sri Lanka?", answer: "colombo", category: "Capitals", points: 15 },
  { id: "cap8", question: "What is the capital of Brunei?", answer: "bandar seri begawan", category: "Capitals", points: 25 },
  { id: "cap9", question: "What is the capital of Nepal?", answer: "kathmandu", category: "Capitals", points: 15 },
  { id: "cap10", question: "What is the capital of Iceland?", answer: "reykjavik", category: "Capitals", points: 15 },
  { id: "cap11", question: "What is the capital of Peru?", answer: "lima", category: "Capitals", points: 10 },
  { id: "cap12", question: "What is the capital of Ukraine?", answer: "kyiv", category: "Capitals", points: 10 },
  { id: "cap13", question: "What is the capital of Vietnam?", answer: "hanoi", category: "Capitals", points: 15 },
  { id: "cap14", question: "What is the capital of Morocco?", answer: "rabat", category: "Capitals", points: 15 },
  { id: "cap15", question: "What is the capital of Finland?", answer: "helsinki", category: "Capitals", points: 10 },
  
  // Science (15)
  { id: "sci1", question: "What is the atomic number of Gold?", answer: "79", category: "Science", points: 15 },
  { id: "sci2", question: "What planet has the most moons?", answer: "saturn", category: "Science", points: 15 },
  { id: "sci3", question: "What element has the symbol 'Pb'?", answer: "lead", category: "Science", points: 15 },
  { id: "sci4", question: "What is the hardest natural substance?", answer: "diamond", category: "Science", points: 10 },
  { id: "sci5", question: "How many bones in the adult human body?", answer: "206", category: "Science", points: 15 },
  { id: "sci6", question: "What is the chemical formula for water?", answer: "h2o", category: "Science", points: 10 },
  { id: "sci7", question: "What planet is known as the Red Planet?", answer: "mars", category: "Science", points: 10 },
  { id: "sci8", question: "What gas do plants absorb from the air?", answer: "carbon dioxide", category: "Science", points: 10 },
  { id: "sci9", question: "What is the largest organ in the human body?", answer: "skin", category: "Science", points: 10 },
  { id: "sci10", question: "What force keeps us on the ground?", answer: "gravity", category: "Science", points: 10 },
  { id: "sci11", question: "What element does 'O' represent?", answer: "oxygen", category: "Science", points: 10 },
  { id: "sci12", question: "How many chromosomes do humans have?", answer: "46", category: "Science", points: 15 },
  { id: "sci13", question: "What is the center of an atom called?", answer: "nucleus", category: "Science", points: 15 },
  { id: "sci14", question: "What type of animal is a dolphin?", answer: "mammal", category: "Science", points: 10 },
  { id: "sci15", question: "What planet is closest to the sun?", answer: "mercury", category: "Science", points: 10 },
  
  // History (10)
  { id: "his1", question: "In what year did the Berlin Wall fall?", answer: "1989", category: "History", points: 15 },
  { id: "his2", question: "What year did the Titanic sink?", answer: "1912", category: "History", points: 15 },
  { id: "his3", question: "When was the Declaration of Independence signed?", answer: "1776", category: "History", points: 10 },
  { id: "his4", question: "What year did man first walk on the moon?", answer: "1969", category: "History", points: 10 },
  { id: "his5", question: "In what year did World War II end?", answer: "1945", category: "History", points: 10 },
  { id: "his6", question: "Who was the first President of the USA?", answer: "george washington", category: "History", points: 10 },
  { id: "his7", question: "What ancient wonder was in Egypt?", answer: "pyramids", category: "History", points: 10 },
  { id: "his8", question: "Who discovered America in 1492?", answer: "columbus", category: "History", points: 10 },
  { id: "his9", question: "What empire built the Colosseum?", answer: "roman", category: "History", points: 10 },
  { id: "his10", question: "Who was known as the 'Maid of Orleans'?", answer: "joan of arc", category: "History", points: 15 },
  
  // Math (10)
  { id: "mat1", question: "What is the square root of 144?", answer: "12", category: "Math", points: 10 },
  { id: "mat2", question: "What is 15 x 15?", answer: "225", category: "Math", points: 10 },
  { id: "mat3", question: "What is 20% of 500?", answer: "100", category: "Math", points: 10 },
  { id: "mat4", question: "How many sides does a hexagon have?", answer: "6", category: "Math", points: 10 },
  { id: "mat5", question: "What is 2 to the power of 8?", answer: "256", category: "Math", points: 15 },
  { id: "mat6", question: "What is the square root of 81?", answer: "9", category: "Math", points: 10 },
  { id: "mat7", question: "What is 17 + 28?", answer: "45", category: "Math", points: 10 },
  { id: "mat8", question: "How many degrees in a right angle?", answer: "90", category: "Math", points: 10 },
  { id: "mat9", question: "What is 1000 divided by 8?", answer: "125", category: "Math", points: 15 },
  { id: "mat10", question: "What is the next prime after 7?", answer: "11", category: "Math", points: 10 },
];

// TV, Movies & Actors Trivia (50 questions)
const TV_MOVIES_QUESTIONS = [
  { id: "tv1", question: "Who played the Joker in The Dark Knight?", answer: "heath ledger", category: "Movies", points: 10 },
  { id: "tv2", question: "What movie won Best Picture in 2020?", answer: "parasite", category: "Movies", points: 15 },
  { id: "tv3", question: "Who directed Inception?", answer: "christopher nolan", category: "Movies", points: 15 },
  { id: "tv4", question: "Who played Iron Man?", answer: "robert downey jr", category: "Movies", points: 10 },
  { id: "tv5", question: "What year was the first Star Wars released?", answer: "1977", category: "Movies", points: 15 },
  { id: "tv6", question: "Who played Forrest Gump?", answer: "tom hanks", category: "Movies", points: 10 },
  { id: "tv7", question: "Who directed Pulp Fiction?", answer: "quentin tarantino", category: "Movies", points: 10 },
  { id: "tv8", question: "Who played Hermione in Harry Potter?", answer: "emma watson", category: "Movies", points: 10 },
  { id: "tv9", question: "What was the first Pixar movie?", answer: "toy story", category: "Movies", points: 10 },
  { id: "tv10", question: "Who played Jack in Titanic?", answer: "leonardo dicaprio", category: "Movies", points: 10 },
  { id: "tv11", question: "What movie features 'I'll be back'?", answer: "terminator", category: "Movies", points: 10 },
  { id: "tv12", question: "Who played Wolverine?", answer: "hugh jackman", category: "Movies", points: 10 },
  { id: "tv13", question: "What franchise features Hogwarts?", answer: "harry potter", category: "Movies", points: 10 },
  { id: "tv14", question: "Who directed Jurassic Park?", answer: "steven spielberg", category: "Movies", points: 15 },
  { id: "tv15", question: "Who played Batman in the Dark Knight?", answer: "christian bale", category: "Movies", points: 10 },
  { id: "tv16", question: "What movie has the line 'Here's Johnny'?", answer: "the shining", category: "Movies", points: 15 },
  { id: "tv17", question: "Who played Neo in The Matrix?", answer: "keanu reeves", category: "Movies", points: 10 },
  { id: "tv18", question: "What movie features a volleyball named Wilson?", answer: "cast away", category: "Movies", points: 15 },
  { id: "tv19", question: "Who played Captain Jack Sparrow?", answer: "johnny depp", category: "Movies", points: 10 },
  { id: "tv20", question: "What movie features singing nuns?", answer: "the sound of music", category: "Movies", points: 15 },
  // TV Shows
  { id: "tv21", question: "What show features Tyrion Lannister?", answer: "game of thrones", category: "TV", points: 10 },
  { id: "tv22", question: "Who created Breaking Bad?", answer: "vince gilligan", category: "TV", points: 20 },
  { id: "tv23", question: "What show is set in Hawkins, Indiana?", answer: "stranger things", category: "TV", points: 10 },
  { id: "tv24", question: "What show features Sheldon Cooper?", answer: "the big bang theory", category: "TV", points: 10 },
  { id: "tv25", question: "Who plays Eleven in Stranger Things?", answer: "millie bobby brown", category: "TV", points: 15 },
  { id: "tv26", question: "What show features a chemistry teacher turned drug lord?", answer: "breaking bad", category: "TV", points: 10 },
  { id: "tv27", question: "What animated show is set in Springfield?", answer: "the simpsons", category: "TV", points: 10 },
  { id: "tv28", question: "What show features the Targaryen family?", answer: "game of thrones", category: "TV", points: 10 },
  { id: "tv29", question: "Who plays Walter White?", answer: "bryan cranston", category: "TV", points: 15 },
  { id: "tv30", question: "What show is about paper salesmen in Scranton?", answer: "the office", category: "TV", points: 10 },
  { id: "tv31", question: "What show features Rachel, Monica, and Phoebe?", answer: "friends", category: "TV", points: 10 },
  { id: "tv32", question: "Who plays Jon Snow?", answer: "kit harington", category: "TV", points: 15 },
  { id: "tv33", question: "What show features a yellow sponge?", answer: "spongebob squarepants", category: "TV", points: 10 },
  { id: "tv34", question: "What crime show is set in Baltimore?", answer: "the wire", category: "TV", points: 20 },
  { id: "tv35", question: "Who plays Michael Scott in The Office?", answer: "steve carell", category: "TV", points: 10 },
  { id: "tv36", question: "What show is about a time-traveling phone booth?", answer: "doctor who", category: "TV", points: 15 },
  { id: "tv37", question: "What animated show features Cartman, Kyle, Stan?", answer: "south park", category: "TV", points: 10 },
  { id: "tv38", question: "Who plays Daenerys Targaryen?", answer: "emilia clarke", category: "TV", points: 15 },
  { id: "tv39", question: "What show features Ted, Marshall, and Barney?", answer: "how i met your mother", category: "TV", points: 10 },
  { id: "tv40", question: "What show is about survivors on a mysterious island?", answer: "lost", category: "TV", points: 15 },
  { id: "tv41", question: "Who plays Chandler in Friends?", answer: "matthew perry", category: "TV", points: 10 },
  { id: "tv42", question: "What show features Dexter Morgan?", answer: "dexter", category: "TV", points: 15 },
  { id: "tv43", question: "What animated show is about a dysfunctional family in Rhode Island?", answer: "family guy", category: "TV", points: 10 },
  { id: "tv44", question: "Who plays Cersei Lannister?", answer: "lena headey", category: "TV", points: 15 },
  { id: "tv45", question: "What show is about meth cooks in Albuquerque?", answer: "breaking bad", category: "TV", points: 10 },
  { id: "tv46", question: "What sitcom is set in a coffee shop called Central Perk?", answer: "friends", category: "TV", points: 10 },
  { id: "tv47", question: "What show features dragons and White Walkers?", answer: "game of thrones", category: "TV", points: 10 },
  { id: "tv48", question: "Who plays Jesse Pinkman?", answer: "aaron paul", category: "TV", points: 15 },
  { id: "tv49", question: "What Netflix show is about a tiger-owning zoo keeper?", answer: "tiger king", category: "TV", points: 10 },
  { id: "tv50", question: "What show is about a high school teacher diagnosed with cancer?", answer: "breaking bad", category: "TV", points: 10 },
];

// Cartoons, Disney & Artists Trivia (50 questions)
const CARTOONS_DISNEY_QUESTIONS = [
  { id: "car1", question: "What is the snowman's name in Frozen?", answer: "olaf", category: "Disney", points: 10 },
  { id: "car2", question: "Who lives in a pineapple under the sea?", answer: "spongebob", category: "Cartoons", points: 10 },
  { id: "car3", question: "What Disney princess has a tiger named Rajah?", answer: "jasmine", category: "Disney", points: 15 },
  { id: "car4", question: "Who painted the Sistine Chapel ceiling?", answer: "michelangelo", category: "Art", points: 15 },
  { id: "car5", question: "Who painted The Starry Night?", answer: "van gogh", category: "Art", points: 10 },
  { id: "car6", question: "What is Simba's father's name?", answer: "mufasa", category: "Disney", points: 10 },
  { id: "car7", question: "What Disney movie has a genie?", answer: "aladdin", category: "Disney", points: 10 },
  { id: "car8", question: "Who painted the Mona Lisa?", answer: "leonardo da vinci", category: "Art", points: 10 },
  { id: "car9", question: "What cartoon features Bugs Bunny?", answer: "looney tunes", category: "Cartoons", points: 10 },
  { id: "car10", question: "What Disney movie features a wooden puppet?", answer: "pinocchio", category: "Disney", points: 10 },
  { id: "car11", question: "Who is Mickey Mouse's girlfriend?", answer: "minnie", category: "Disney", points: 10 },
  { id: "car12", question: "What princess has seven dwarf friends?", answer: "snow white", category: "Disney", points: 10 },
  { id: "car13", question: "What cartoon dog says 'Scooby Dooby Doo'?", answer: "scooby doo", category: "Cartoons", points: 10 },
  { id: "car14", question: "What artist cut off his own ear?", answer: "van gogh", category: "Art", points: 15 },
  { id: "car15", question: "What Disney princess has magical hair?", answer: "rapunzel", category: "Disney", points: 10 },
  { id: "car16", question: "What cartoon features a talking dog and mystery solving?", answer: "scooby doo", category: "Cartoons", points: 10 },
  { id: "car17", question: "Who is Woody's cowgirl friend in Toy Story?", answer: "jessie", category: "Disney", points: 10 },
  { id: "car18", question: "What princess kisses a frog?", answer: "tiana", category: "Disney", points: 15 },
  { id: "car19", question: "What cartoon features Patrick Star?", answer: "spongebob squarepants", category: "Cartoons", points: 10 },
  { id: "car20", question: "Who painted 'The Persistence of Memory' with melting clocks?", answer: "salvador dali", category: "Art", points: 20 },
  { id: "car21", question: "What Disney movie features a magic carpet?", answer: "aladdin", category: "Disney", points: 10 },
  { id: "car22", question: "What is Nemo's dad's name?", answer: "marlin", category: "Disney", points: 15 },
  { id: "car23", question: "What Disney princess can control ice and snow?", answer: "elsa", category: "Disney", points: 10 },
  { id: "car24", question: "What cartoon cat chases Jerry?", answer: "tom", category: "Cartoons", points: 10 },
  { id: "car25", question: "Who is the villain in The Little Mermaid?", answer: "ursula", category: "Disney", points: 15 },
  { id: "car26", question: "What Disney movie features talking toys?", answer: "toy story", category: "Disney", points: 10 },
  { id: "car27", question: "What cartoon features a sponge who works at the Krusty Krab?", answer: "spongebob squarepants", category: "Cartoons", points: 10 },
  { id: "car28", question: "Who painted 'Girl with a Pearl Earring'?", answer: "vermeer", category: "Art", points: 20 },
  { id: "car29", question: "What is the name of the dinglehopper princess?", answer: "ariel", category: "Disney", points: 15 },
  { id: "car30", question: "What Disney movie features the song 'Let It Go'?", answer: "frozen", category: "Disney", points: 10 },
  { id: "car31", question: "Who is the space ranger in Toy Story?", answer: "buzz lightyear", category: "Disney", points: 10 },
  { id: "car32", question: "What princess loses her glass slipper?", answer: "cinderella", category: "Disney", points: 10 },
  { id: "car33", question: "What cartoon dog lives with Charlie Brown?", answer: "snoopy", category: "Cartoons", points: 10 },
  { id: "car34", question: "What Disney movie features Hades as the villain?", answer: "hercules", category: "Disney", points: 15 },
  { id: "car35", question: "What is the fish's name in Pinocchio?", answer: "cleo", category: "Disney", points: 20 },
  { id: "car36", question: "What cartoon features a pink panther?", answer: "the pink panther", category: "Cartoons", points: 10 },
  { id: "car37", question: "What Disney movie has a flying elephant?", answer: "dumbo", category: "Disney", points: 10 },
  { id: "car38", question: "Who painted 'The Scream'?", answer: "edvard munch", category: "Art", points: 20 },
  { id: "car39", question: "What is the monkey's name in Aladdin?", answer: "abu", category: "Disney", points: 15 },
  { id: "car40", question: "What cartoon features Wile E. Coyote?", answer: "looney tunes", category: "Cartoons", points: 10 },
  { id: "car41", question: "What Disney villain turns into a dragon?", answer: "maleficent", category: "Disney", points: 15 },
  { id: "car42", question: "What is the cat's name in Cinderella?", answer: "lucifer", category: "Disney", points: 20 },
  { id: "car43", question: "What cartoon features Bart, Lisa, and Maggie?", answer: "the simpsons", category: "Cartoons", points: 10 },
  { id: "car44", question: "What Disney princess is Chinese?", answer: "mulan", category: "Disney", points: 10 },
  { id: "car45", question: "Who is the villain in 101 Dalmatians?", answer: "cruella de vil", category: "Disney", points: 15 },
  { id: "car46", question: "What cartoon features a baby named Stewie?", answer: "family guy", category: "Cartoons", points: 10 },
  { id: "car47", question: "What Disney movie features talking cars?", answer: "cars", category: "Disney", points: 10 },
  { id: "car48", question: "What is the robot's name in Wall-E?", answer: "eve", category: "Disney", points: 15 },
  { id: "car49", question: "What cartoon rabbit says 'What's up, Doc?'?", answer: "bugs bunny", category: "Cartoons", points: 10 },
  { id: "car50", question: "What Disney movie features the villain Jafar?", answer: "aladdin", category: "Disney", points: 10 },
];

// World History & Disasters Trivia (50 questions)
const HISTORY_DISASTERS_QUESTIONS = [
  { id: "hd1", question: "What year did World War I start?", answer: "1914", category: "History", points: 15 },
  { id: "hd2", question: "What year did World War II end?", answer: "1945", category: "History", points: 10 },
  { id: "hd3", question: "What city was destroyed by Mount Vesuvius?", answer: "pompeii", category: "Disasters", points: 15 },
  { id: "hd4", question: "What ship sank in 1912?", answer: "titanic", category: "Disasters", points: 10 },
  { id: "hd5", question: "Who was the first US President?", answer: "george washington", category: "History", points: 10 },
  { id: "hd6", question: "What plague killed millions in the 1300s?", answer: "black death", category: "Disasters", points: 15 },
  { id: "hd7", question: "Who discovered America?", answer: "columbus", category: "History", points: 10 },
  { id: "hd8", question: "What nuclear plant had a disaster in 1986?", answer: "chernobyl", category: "Disasters", points: 15 },
  { id: "hd9", question: "Who was the Queen of England for 70 years?", answer: "elizabeth ii", category: "History", points: 10 },
  { id: "hd10", question: "What hurricane devastated New Orleans in 2005?", answer: "katrina", category: "Disasters", points: 10 },
  { id: "hd11", question: "Who painted the Mona Lisa?", answer: "leonardo da vinci", category: "History", points: 10 },
  { id: "hd12", question: "What earthquake struck Japan in 2011?", answer: "fukushima", category: "Disasters", points: 15 },
  { id: "hd13", question: "Who built the Great Wall of China?", answer: "china", category: "History", points: 10 },
  { id: "hd14", question: "What pandemic started in 2020?", answer: "covid", category: "Disasters", points: 10 },
  { id: "hd15", question: "Who was the first man on the moon?", answer: "neil armstrong", category: "History", points: 10 },
  { id: "hd16", question: "What space shuttle exploded in 1986?", answer: "challenger", category: "Disasters", points: 15 },
  { id: "hd17", question: "What Egyptian queen loved Julius Caesar?", answer: "cleopatra", category: "History", points: 10 },
  { id: "hd18", question: "What tsunami killed 230,000 in 2004?", answer: "indian ocean", category: "Disasters", points: 15 },
  { id: "hd19", question: "Who freed American slaves?", answer: "abraham lincoln", category: "History", points: 10 },
  { id: "hd20", question: "What volcano buried Pompeii?", answer: "vesuvius", category: "Disasters", points: 10 },
  { id: "hd21", question: "What war was fought between North and South America?", answer: "civil war", category: "History", points: 10 },
  { id: "hd22", question: "What fire destroyed much of London in 1666?", answer: "great fire of london", category: "Disasters", points: 15 },
  { id: "hd23", question: "Who was the first female Prime Minister of UK?", answer: "margaret thatcher", category: "History", points: 15 },
  { id: "hd24", question: "What disease was called the Spanish Flu?", answer: "influenza", category: "Disasters", points: 15 },
  { id: "hd25", question: "What wall fell in 1989?", answer: "berlin wall", category: "History", points: 10 },
  { id: "hd26", question: "What nuclear bomb was dropped on Japan?", answer: "hiroshima", category: "Disasters", points: 15 },
  { id: "hd27", question: "Who invented the printing press?", answer: "gutenberg", category: "History", points: 15 },
  { id: "hd28", question: "What oil spill occurred in the Gulf of Mexico in 2010?", answer: "deepwater horizon", category: "Disasters", points: 20 },
  { id: "hd29", question: "What ancient civilization built the Pyramids?", answer: "egypt", category: "History", points: 10 },
  { id: "hd30", question: "What city was bombed in the blitz of WWII?", answer: "london", category: "Disasters", points: 15 },
  { id: "hd31", question: "Who wrote the Declaration of Independence?", answer: "thomas jefferson", category: "History", points: 10 },
  { id: "hd32", question: "What earthquake devastated San Francisco in 1906?", answer: "san francisco", category: "Disasters", points: 10 },
  { id: "hd33", question: "What explorer sailed for Spain in 1492?", answer: "columbus", category: "History", points: 10 },
  { id: "hd34", question: "What disease killed millions in the Middle Ages?", answer: "plague", category: "Disasters", points: 15 },
  { id: "hd35", question: "Who was the first Roman Emperor?", answer: "augustus", category: "History", points: 20 },
  { id: "hd36", question: "What ship's sister ship to the Titanic also sank?", answer: "britannic", category: "Disasters", points: 25 },
  { id: "hd37", question: "What revolution started in France in 1789?", answer: "french revolution", category: "History", points: 10 },
  { id: "hd38", question: "What famine killed millions in Ireland in the 1840s?", answer: "potato famine", category: "Disasters", points: 15 },
  { id: "hd39", question: "Who led India to independence?", answer: "gandhi", category: "History", points: 10 },
  { id: "hd40", question: "What tornado killed 695 in 1925 USA?", answer: "tri-state tornado", category: "Disasters", points: 25 },
  { id: "hd41", question: "What empire did Genghis Khan build?", answer: "mongol", category: "History", points: 15 },
  { id: "hd42", question: "What Greek city-state was known for warriors?", answer: "sparta", category: "History", points: 15 },
  { id: "hd43", question: "What Japanese city was the second atomic bomb target?", answer: "nagasaki", category: "Disasters", points: 15 },
  { id: "hd44", question: "Who was the dictator of Nazi Germany?", answer: "hitler", category: "History", points: 10 },
  { id: "hd45", question: "What hurricane killed 8,000 in Galveston in 1900?", answer: "galveston hurricane", category: "Disasters", points: 20 },
  { id: "hd46", question: "What Greek philosopher drank poison?", answer: "socrates", category: "History", points: 15 },
  { id: "hd47", question: "What industrial disaster killed 4,000 in India 1984?", answer: "bhopal", category: "Disasters", points: 20 },
  { id: "hd48", question: "Who led the Soviet Union during WWII?", answer: "stalin", category: "History", points: 15 },
  { id: "hd49", question: "What flood killed millions in China in 1931?", answer: "yangtze", category: "Disasters", points: 25 },
  { id: "hd50", question: "What ancient city had hanging gardens?", answer: "babylon", category: "History", points: 15 },
];

// Question interval configuration
const QUESTION_INTERVAL_SECONDS = 15; // Time between questions
const QUESTION_TIME_LIMIT = 30; // Seconds to answer each question

// TriviaPanel Component - Minimal UI, questions go to chat
const TriviaPanel = ({ 
  roomId, 
  wsRef, 
  messages,
  onAddTriviaMessage, 
  API,
  token 
}) => {
  // Determine which trivia room this is and which questions to use
  const getQuestionsForRoom = () => {
    if (roomId === "tv-movies-trivia-room") return TV_MOVIES_QUESTIONS;
    if (roomId === "cartoons-trivia-room") return CARTOONS_DISNEY_QUESTIONS;
    if (roomId === "history-trivia-room") return HISTORY_DISASTERS_QUESTIONS;
    return MAIN_TRIVIA_QUESTIONS;
  };

  const questions = getQuestionsForRoom();
  const shouldShow = ["trivia-room", "main-trivia-room", "tv-movies-trivia-room", "cartoons-trivia-room", "history-trivia-room"].includes(roomId);

  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [questionActive, setQuestionActive] = useState(false);
  const [autoMode, setAutoMode] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [cooldownQuestions, setCooldownQuestions] = useState(new Set());
  const [questionCount, setQuestionCount] = useState(0);
  
  const timerRef = useRef(null);
  const nextQuestionTimeoutRef = useRef(null);
  const questionActiveRef = useRef(false); // Track if question is active for callbacks

  // Keep ref in sync with state
  useEffect(() => {
    questionActiveRef.current = questionActive;
  }, [questionActive]);

  // Fetch cooldown questions
  const fetchCooldownQuestions = useCallback(async () => {
    if (!shouldShow) return;
    try {
      const response = await axios.get(`${API}/trivia/available-questions/${roomId}`);
      setCooldownQuestions(new Set(response.data.on_cooldown));
    } catch (error) {
      console.error("Failed to fetch cooldown questions:", error);
    }
  }, [shouldShow, API, roomId]);

  useEffect(() => {
    fetchCooldownQuestions();
  }, [fetchCooldownQuestions]);

  // Keep track of recently used questions locally for this session
  const [localUsedQuestions, setLocalUsedQuestions] = useState(new Set());

  // Get next question (excluding cooldown and locally used)
  const getNextQuestion = useCallback(() => {
    // Combine backend cooldown with local usage
    const allUsed = new Set([...cooldownQuestions, ...localUsedQuestions]);
    const availableQuestions = questions.filter(q => !allUsed.has(q.id));
    
    // If we've used all questions, reset local tracking
    if (availableQuestions.length === 0) {
      setLocalUsedQuestions(new Set());
      // Shuffle and pick randomly from all questions
      const shuffled = [...questions].sort(() => Math.random() - 0.5);
      return shuffled[0];
    }
    
    // Shuffle available questions and pick the first one (truly random)
    const shuffled = [...availableQuestions].sort(() => Math.random() - 0.5);
    return shuffled[0];
  }, [questions, cooldownQuestions, localUsedQuestions]);

  // Mark question as used
  const markQuestionUsed = useCallback(async (questionId) => {
    // Mark locally immediately
    setLocalUsedQuestions(prev => new Set([...prev, questionId]));
    
    try {
      await axios.post(`${API}/trivia/question-used`, { 
        question_id: questionId, 
        room_id: roomId 
      });
      setCooldownQuestions(prev => new Set([...prev, questionId]));
    } catch (error) {
      console.error("Failed to mark question as used:", error);
    }
  }, [API, roomId]);

  // Store callback in ref to avoid stale closures
  const onAddTriviaMessageRef = useRef(onAddTriviaMessage);
  useEffect(() => {
    onAddTriviaMessageRef.current = onAddTriviaMessage;
  }, [onAddTriviaMessage]);

  // Send message to chat as a system-style message
  const sendToChatFn = useCallback((content) => {
    // Add message to chat locally as a trivia bot message
    const callback = onAddTriviaMessageRef.current;
    console.log("Trivia sendToChatFn called:", content, "callback exists:", !!callback);
    if (callback) {
      const msg = {
        message_id: `trivia-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        content: content,
        username: "🧠 Trivia Bot",
        sender_id: "trivia-bot",
        is_system: true,
        is_trivia: true,
        timestamp: new Date().toISOString()
      };
      console.log("Trivia: Adding message to chat:", msg);
      callback(msg);
    }
  }, []);

  // Schedule next question
  const scheduleNextQuestion = useCallback(() => {
    // Clear any existing timeout
    if (nextQuestionTimeoutRef.current) {
      clearTimeout(nextQuestionTimeoutRef.current);
      nextQuestionTimeoutRef.current = null;
    }
    
    // Schedule next question
    nextQuestionTimeoutRef.current = setTimeout(() => {
      // Double check conditions before asking
      if (autoMode && !isPaused) {
        askNewQuestion();
      }
    }, QUESTION_INTERVAL_SECONDS * 1000);
  }, [autoMode, isPaused]);

  // Ask a new question
  const askNewQuestion = useCallback(() => {
    // Prevent asking while already active
    if (questionActiveRef.current) return;
    
    // Clear existing timer
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    
    const question = getNextQuestion();
    setCurrentQuestion(question);
    setQuestionActive(true);
    questionActiveRef.current = true;
    setQuestionCount(prev => prev + 1);

    markQuestionUsed(question.id);

    // Send question to chat as a highlighted message
    sendToChatFn(`🧠 TRIVIA: ${question.question} [${question.category} - ${question.points}pts + 3 F-Chips] ⏱️ 30 seconds!`);

    // Start countdown - time's up handling
    let timeRemaining = QUESTION_TIME_LIMIT;
    timerRef.current = setInterval(() => {
      timeRemaining -= 1;
      
      if (timeRemaining <= 0) {
        // Time's up!
        clearInterval(timerRef.current);
        timerRef.current = null;
        setQuestionActive(false);
        questionActiveRef.current = false;
        
        sendToChatFn(`⏰ TIME'S UP! The answer was: ${question.answer.toUpperCase()}`);
        
        // Schedule next question if auto mode
        if (autoMode && !isPaused) {
          scheduleNextQuestion();
        }
      }
    }, 1000);
  }, [getNextQuestion, markQuestionUsed, sendToChatFn, autoMode, isPaused, scheduleNextQuestion]);

  // Handle correct answer
  const handleCorrectAnswer = useCallback((username, userId, question) => {
    // Stop the timer immediately
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    
    setQuestionActive(false);
    questionActiveRef.current = false;

    // Award points
    try {
      axios.post(`${API}/trivia/score`, { user_id: userId, points: question.points, question_id: question.id, room_id: roomId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error("Failed to save trivia score:", error);
    }

    // Announce winner in chat first - use direct callback to avoid stale closure
    const winnerMsg = `🎉 ${username} GOT IT! Answer: ${question.answer.toUpperCase()} (+${question.points}pts + 3 F-Chips) 🏆`;
    console.log("Trivia: Sending winner message:", winnerMsg);
    sendToChatFn(winnerMsg);

    // Schedule next question if auto mode is on (with delay for winner message to show)
    if (autoMode && !isPaused) {
      // Use longer delay to ensure winner message appears before next question
      setTimeout(() => {
        scheduleNextQuestion();
      }, 1500);
    }
  }, [API, token, roomId, sendToChatFn, autoMode, isPaused, scheduleNextQuestion]);

  // Check answers from chat messages
  useEffect(() => {
    if (!shouldShow || !questionActiveRef.current || !currentQuestion || !messages.length) return;

    const lastMessage = messages[messages.length - 1];
    
    // Skip system messages, trivia bot messages, and non-user messages
    if (lastMessage.is_system || lastMessage.is_trivia || lastMessage.message_type === 'system' || 
        lastMessage.message_type === 'system_broadcast' || !lastMessage.content ||
        !lastMessage.user_id || lastMessage.content.includes('has joined') || 
        lastMessage.content.includes('has left') || lastMessage.content.includes('TRIVIA') ||
        lastMessage.content.includes('GOT IT!') || lastMessage.content.includes('TIME\'S UP!') ||
        lastMessage.sender_id === 'trivia-bot') {
      return;
    }

    const userAnswer = lastMessage.content.toLowerCase().trim();
    const correctAnswer = currentQuestion.answer.toLowerCase().trim();

    // Check if answer is correct (exact match or close enough)
    const isCorrect = userAnswer === correctAnswer || 
      (correctAnswer.length > 5 && userAnswer.includes(correctAnswer)) ||
      (userAnswer.length > 5 && correctAnswer.includes(userAnswer));

    const answererUserId = lastMessage.user_id || lastMessage.sender_id;
    
    if (isCorrect && answererUserId) {
      handleCorrectAnswer(lastMessage.username, answererUserId, currentQuestion);
    }
  }, [shouldShow, messages, currentQuestion, handleCorrectAnswer]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (nextQuestionTimeoutRef.current) clearTimeout(nextQuestionTimeoutRef.current);
    };
  }, []);

  // Start first question when auto mode enabled
  useEffect(() => {
    if (autoMode && !questionActiveRef.current && !isPaused) {
      const startDelay = setTimeout(() => {
        if (!questionActiveRef.current) {
          askNewQuestion();
        }
      }, 2000);
      return () => clearTimeout(startDelay);
    }
  }, [autoMode, isPaused, askNewQuestion]);

  // Toggle pause
  const togglePause = () => {
    if (isPaused) {
      setIsPaused(false);
      // Resume - schedule next question if not currently active
      if (autoMode && !questionActiveRef.current) {
        scheduleNextQuestion();
      }
    } else {
      setIsPaused(true);
      // Pause - clear scheduled next question
      if (nextQuestionTimeoutRef.current) {
        clearTimeout(nextQuestionTimeoutRef.current);
        nextQuestionTimeoutRef.current = null;
      }
    }
  };

  // Toggle auto mode
  const toggleAutoMode = () => {
    if (autoMode) {
      // Turning OFF
      setAutoMode(false);
      if (nextQuestionTimeoutRef.current) {
        clearTimeout(nextQuestionTimeoutRef.current);
        nextQuestionTimeoutRef.current = null;
      }
    } else {
      // Turning ON
      setAutoMode(true);
      setIsPaused(false);
    }
  };

  if (!shouldShow) return null;

  // Compact inline control bar that appears in the chat area
  return (
    <div className="flex-shrink-0 px-2 py-1.5 bg-gradient-to-r from-purple-900/80 to-indigo-900/80 border-b border-purple-500/50 flex items-center gap-3" data-testid="trivia-controls">
      <div className="flex items-center gap-1.5">
        <Trophy className="w-4 h-4 text-yellow-400" />
        <span className="text-white text-xs font-bold">TRIVIA BOT</span>
      </div>
      
      <button
        onClick={toggleAutoMode}
        className={`px-2 py-0.5 rounded text-xs font-bold flex items-center gap-1 ${
          autoMode 
            ? 'bg-green-600 text-white' 
            : 'bg-gray-600 text-gray-200 hover:bg-gray-500'
        }`}
        data-testid="trivia-auto-btn"
      >
        <RefreshCw className={`w-3 h-3 ${autoMode ? 'animate-spin' : ''}`} />
        {autoMode ? 'ON' : 'OFF'}
      </button>
      
      {autoMode && (
        <button
          onClick={togglePause}
          className={`px-2 py-0.5 rounded text-xs font-bold flex items-center gap-1 ${
            isPaused 
              ? 'bg-yellow-600 text-white' 
              : 'bg-gray-600 text-gray-200 hover:bg-gray-500'
          }`}
          data-testid="trivia-pause-btn"
        >
          {isPaused ? <Play className="w-3 h-3" /> : <Pause className="w-3 h-3" />}
          {isPaused ? 'RESUME' : 'PAUSE'}
        </button>
      )}

      {!autoMode && !questionActive && (
        <button
          onClick={askNewQuestion}
          className="px-2 py-0.5 bg-purple-600 hover:bg-purple-500 rounded text-white text-xs font-bold"
          data-testid="trivia-ask-btn"
        >
          ASK QUESTION
        </button>
      )}

      <div className="flex items-center gap-2 text-xs text-gray-300 ml-auto">
        <span>Questions: <span className="text-white font-bold">{questionCount}</span></span>
        <span className="text-gray-500">|</span>
        <span className="flex items-center gap-1">
          <HelpCircle className="w-3 h-3" />
          Type answer in chat
        </span>
      </div>
    </div>
  );
};

export default TriviaPanel;
